import { Plus, X } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { EditableText } from "@/components/EditableText";
import { Reveal } from "@/components/Reveal";

const Menu = () => {
  const { content, admin, addItem, removeItem } = useSite();
  return (
    <section id="menu" data-testid="menu-section" className="scroll-mt-16 px-6 py-28 md:px-12 md:py-40">
      <div className="mx-auto max-w-[1100px]">
        <Reveal>
          <div className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.3em] text-[#5C564D]">
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[#FCDD09]" aria-hidden="true" />
            <EditableText path="menu.heading" testId="menu-heading" />
          </div>
          <p className="mt-6 max-w-lg text-base text-[#5C564D] md:text-lg">
            <EditableText path="menu.note" testId="menu-note" multiline />
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <div className="mt-10 flex flex-wrap gap-2" data-testid="menu-jump-links">
            {content.menu.categories.map((cat, ci) => (
              <button
                key={ci}
                data-testid={`menu-jump-${ci}`}
                onClick={() => document.getElementById(`menu-cat-${ci}`)?.scrollIntoView({ behavior: "smooth" })}
                className="border border-[#1A1713]/15 px-4 py-1.5 text-[11px] font-medium uppercase tracking-[0.15em] text-[#5C564D] transition-colors hover:border-[#1A1713] hover:text-[#1A1713]"
              >
                {cat.name}
              </button>
            ))}
          </div>
        </Reveal>
        <div className="mt-20 space-y-20">
          {content.menu.categories.map((cat, ci) => (
            <Reveal key={ci} delay={0.05}>
              <div id={`menu-cat-${ci}`} data-testid={`menu-category-${ci}`} className="scroll-mt-28">
                <div className="mb-8 flex items-baseline justify-between gap-4 border-b border-[#1A1713]/15 pb-4">
                  <h3 className="font-serif text-2xl italic tracking-tight md:text-3xl">
                    <EditableText path={`menu.categories.${ci}.name`} testId={`menu-category-name-${ci}`} />
                  </h3>
                  {admin && (
                    <button
                      data-testid={`menu-add-item-${ci}`}
                      onClick={() =>
                        addItem(`menu.categories.${ci}.items`, { name: "New dish", desc: "Description", price: "0.00" })
                      }
                      className="flex items-center gap-1 text-[11px] uppercase tracking-widest text-[#078930]"
                    >
                      <Plus className="h-3 w-3" /> Dish
                    </button>
                  )}
                </div>
                <ul className="space-y-7">
                  {cat.items.map((item, ii) => (
                    <li key={ii} data-testid={`menu-item-${ci}-${ii}`}>
                      <div className="flex items-baseline gap-4">
                        <EditableText
                          path={`menu.categories.${ci}.items.${ii}.name`}
                          testId={`menu-item-name-${ci}-${ii}`}
                          className="font-serif text-xl md:text-2xl"
                        />
                        <span className="flex-1 border-b border-dotted border-[#1A1713]/25" aria-hidden="true" />
                        <EditableText
                          path={`menu.categories.${ci}.items.${ii}.price`}
                          testId={`menu-item-price-${ci}-${ii}`}
                          className="text-sm text-[#5C564D] md:text-base"
                        />
                        {admin && (
                          <button
                            data-testid={`menu-remove-item-${ci}-${ii}`}
                            onClick={() => removeItem(`menu.categories.${ci}.items`, ii)}
                            className="text-[#DA121A]"
                          >
                            <X className="h-3.5 w-3.5" />
                          </button>
                        )}
                      </div>
                      <EditableText
                        path={`menu.categories.${ci}.items.${ii}.desc`}
                        testId={`menu-item-desc-${ci}-${ii}`}
                        className="mt-1 block max-w-md text-sm text-[#5C564D]/80"
                        multiline
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Menu;
